import SliderVideos from "components/Slider/Videos";
import "./index.scss";

/**
 * Component: VideosOverview
 *
 * @param {string} type
 */
export default function VideosOverview(type) {
  SliderVideos(`.VideosOverview:.is-${type}`);
}
